export const displayParkingLoaderSelector = ({displayParkingLoader}) => displayParkingLoader